import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TenantService {
  private tenant: string | null = null;

  getTenant(): string | null {
    this.tenant = 'dmflow';
    if (this.tenant) {
      return this.tenant;
    }

    const host = window.location.hostname;
    const parts = host.split('.');

    // funavry.dmqifs.xyz
    if (parts.length >= 3) {
      this.tenant = parts[0];
    }

    return this.tenant;
  }
}
